// #account
export const LOGIN = 'account/Login';
export const LOGOUT = 'account/Logout';
export const AUTHORIZE = 'account/authorize';
export const ACCOUNT = 'account/user';

export const UPDATE_NAVIGATION = "navigation/update"